import React from 'react'

export default function Pagination({currentPage,pages,goToPreviousPage,goToNextPage,pagination}) {

    return (
        <nav style={{ height: '40px', background: 'inherit', marginTop: '10px' }}>
            <ul className="pagination pagination_ticket">
                {pages.length > 1 && <li className={`page-item  ${currentPage === 1 || pages.length === 0 ? 'disabled' : ''}`}  style={{ background: 'inherit' }}><a onClick={goToPreviousPage}  className="page-link"  aria-label="Previous"><span aria-hidden="true">«</span></a></li>}
                {pages.map((number, index) => (
                    <li key={index} onClick={()=>pagination(number)} className={`page-item ${currentPage === number ? 'active' : null}`}><a className="page-link">{number}</a></li>
                ))}
                {pages.length > 1 && <li className={`page-item ${currentPage === pages.length || pages.length === 0  ? 'disabled' : ''}`} ><a  onClick={goToNextPage} className="page-link"  aria-label="Next"><span aria-hidden="true">»</span></a></li>}
            </ul>
        </nav>
    )
}
